import React from "react";
import DestinationBanner from "../../reusable/DestinationBanner";
import Traveller from "./Traveller";
import StayTouch from "../../layout/StayTouch";
import layoutWrapper from "../../components/Hoc/layoutWrapper";
class GetWifiGlobal extends React.Component {
  render() {
    return (
      <div>
        <DestinationBanner
          bannerTitle="GLOBAL"
          bannerImg="/images/get-wifi-us-global.jpg"
        />
        <Traveller />
        <StayTouch />
      </div>
    );
  }
}

export default layoutWrapper(GetWifiGlobal);



// WEBPACK FOOTER //
// ./src/pages/getwifiglobal/index.js